export default "__VITE_ASSET__CSjgMY$p__"